import { OBJECT_COLOR_PALETTE } from '@utils/constants';
import { subjectsOf } from './subjectWords';

/**
 * The kinds of object one analysis counts (tracks.json `label` per track, from one search for several kinds; backend
 * services/video/kinds.py): their order, a colour each, and how many of each. A video with one kind has no labels or
 * one, and looks as before: everything in the brand green.
 */

const BRAND_GREEN = '#20AC6B';
// the first kind keeps the brand green; then colours from the shared palette far from it and from each other
const KIND_COLORS = [BRAND_GREEN, ...[6, 2, 0, 8, 1, 5, 7].map(i => OBJECT_COLOR_PALETTE[i])];

const rgbOf = hex => {
	const n = parseInt(hex.slice(1), 16);
	return `${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}`;
};

/** The kinds in order: as the request named them (the subject), then any other label the tracks carry. */
export const kindsOf = doc => {
	const labels = new Set((doc?.tracks || []).map(tr => tr.label).filter(Boolean));
	if (labels.size < 2) return [];
	const named = subjectsOf(doc?.subject).filter(k => labels.has(k));
	return [...named, ...[...labels].filter(k => !named.includes(k))];
};

/** { kind: { hex, rgb } } for the kinds, the canvas drawing with `rgb` ("32, 172, 107"). */
export const kindColors = kinds =>
	Object.fromEntries(
		kinds.map((k, i) => {
			const hex = KIND_COLORS[i % KIND_COLORS.length];
			return [k, { hex, rgb: rgbOf(hex) }];
		})
	);

/** How many of each kind among `tracks`: [{ kind, n }] in the kinds' order, kinds with none left out. */
export const countByKind = (tracks, kinds) => {
	const n = Object.fromEntries(kinds.map(k => [k, 0]));
	tracks.forEach(tr => {
		if (tr.label in n) n[tr.label] += 1;
	});
	return kinds.map(kind => ({ kind, n: n[kind] })).filter(c => c.n > 0);
};
